import Vue from "vue"
import Router from "vue-router"
import {getCookie} from "../utils";

Vue.use(Router)

export const fixedRoutes = [
  {
    //考试说明步骤
    path: '/entry',
    name: 'Entry',
    component: () => import("@/views/Entry"),
  },
  {
    //考试说明步骤
    path: '/realMockExam',
    name: 'RealMockExam',
    component: () => import("@/views/RealMockExam"),
    redirect: '/realMockExam/step1',
    children: [
      {
        path: 'step1',
        name: 'Step1',
        component: () => import('@/views/RealMockExam/step1')
      },
      {
        path: 'step2',
        name: 'Step2',
        component: () => import('@/views/RealMockExam/step2')
      },
      {
        path: 'step3',
        name: 'Step3',
        component: () => import('@/views/RealMockExam/step3')
      }
    ]
  },
  {
    //试题收藏
    path: '/collect',
    name: 'Collect',
    component: () => import('@/views/Collect/index')
  },
  {
    //做题记录
    path: '/record',
    name: 'Record',
    component: () => import('@/views/Record/index')
  }
]

const createRouter = () => new Router({
  base: "/",
  routes: fixedRoutes
})

const router = createRouter()

//设置路由导航守卫
router.beforeEach((to, from, next) => {
  // to要去的页面 from从哪里来 next放行
  const userID = getCookie('cdeluid') ? Number(getCookie('cdeluid')) : null
 /* if (userID) {
    next()
  } else {
    //弹窗登录
    window.CDEL.islogin()
  }*/
  next()
})

export default router
